import React from "react";
import "./articleList.css";

const ArticleRow = ({ image, title, buzzword, link }) => (
  <div className="article-row">
    <img src={image} alt={title} className="article-thumb" />
    <div className="article-text">
      <h3 className="article-heading">{title}</h3>
      <p className="article-buzzword">{buzzword}</p>
    </div>
    <a
      className="learn-more-btn"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      Learn&nbsp;More
    </a>
  </div>
);

export default ArticleRow;
